import { createSlice } from "@reduxjs/toolkit";
import { getCommentsOfNew, getNew, getNews, submitCommentsOfNew } from "../api/news";


const initialState = {
   isLoadingNews : false,
   isLoadingNew : false,
   isLoadingComments:false,
   isLoadingSubmitComments:false,
   news:[],
   new:[],
   comments:[],
   submit:[]
   
}

export const NewsSlice = createSlice({
    name:'news',
    initialState,
    extraReducers :{
        [getNews.pending] : (state,{payload}) => {
            return {
                ...state,
                isLoadingNews:true,
                news:[]
            }
        },
        [getNews.fulfilled] : (state,{payload}) => {
            return {
                ...state,
                isLoadingNews:false,
                news:payload
            }
        },
        [getNew.pending] : (state,{payload}) => {
            return {
                ...state,
                isLoadingNew:true,
                new:payload
            }
        },
        [getNew.fulfilled] : (state,{payload}) => {
            return {
                ...state,
                isLoadingNew:false,
                new:payload
            }
        },
        [getCommentsOfNew.pending] : (state,{payload}) => {
            return {
                ...state,
                isLoadingComments:true,
                comments:[]
            }
        },
        [getCommentsOfNew.fulfilled] : (state,{payload}) => {
            
            return {
                ...state,
                isLoadingComments:false,
                comments:payload
            }
        },
        [submitCommentsOfNew.pending] : (state,{payload}) => {
            return {
                ...state,
                isLoadingSubmitComments:true,
                submit:[]
            }
        },
        [submitCommentsOfNew.fulfilled] : (state,{payload}) => {
            return {
                ...state,
                isLoadingSubmitComments:false,
                submit:payload
            }
        },
    }
})


export default NewsSlice.reducer